<!-- header -->
<app-header></app-header>

<!-- routes -->
<router-outlet></router-outlet>

<!-- footer -->
<app-footer></app-footer>
